import { inject, Injectable } from '@angular/core'
import { RouterStateSnapshot, UrlTree, Router, ActivatedRouteSnapshot } from '@angular/router'

import { Store } from '@ngrx/store'
import { Observable } from 'rxjs'
import { map, take } from 'rxjs/operators'

import { RouteUrl } from '@core/enums/routing.enums'
import { trimUrl } from '@core/utils/main.utils'
import { selectNoCompetitions } from '@features/seasons/state/selectors/seasons.selectors'

const ALLOWED_URLS_WITHOUT_COMPETITIONS = new RegExp(
  `^(${RouteUrl.More}|${RouteUrl.MainMore}|${RouteUrl.NoCompetitions}|${RouteUrl.NotPermitted}|${RouteUrl.NetworkTimeout})(/|$)`
)

export const isUrlAllowedWithoutCompetitions = (url: string): boolean =>
  ALLOWED_URLS_WITHOUT_COMPETITIONS.test(trimUrl(url).split('?')[0])

@Injectable({
  providedIn: 'root'
})
export class NoCompetitionsGuard {
  private readonly _store: Store = inject(Store)
  private readonly _router: Router = inject(Router)

  canActivateChild(_route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    return this._store.select(selectNoCompetitions).pipe(
      take(1),
      map((noCompetitions) =>
        !noCompetitions || isUrlAllowedWithoutCompetitions(state.url)
          ? true
          : this._router.createUrlTree([RouteUrl.NoCompetitions])
      )
    )
  }
}
